import AAlert from './index.vue';

AAlert.install = app => {
  app.component(AAlert.name, AAlert);
};

export default AAlert;
